import { styled } from '@mui/material/styles';

import BottomSheet from 'src/components/BottomSheet';

export const Container = styled('div')({
  height: '100%',

  padding: '4rem 0 0 0',
  overflow: 'hidden',

  display: 'flex',
  flexDirection: 'column',
});

export const ValidatorContainer = styled('div')({
  width: '100%',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  overflow: 'auto',
});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  flexShrink: 0,

  padding: '0 4rem',
});

export const HeaderTitle = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const ValidatorList = styled('div')({
  width: '100%',

  marginTop: '2.7rem',

  display: 'grid',
  gridTemplateColumns: '1fr',

  overflow: 'auto',
});

export const Divider = styled('div')(({ theme }) => ({
  width: 'calc(100% - 8rem)',

  display: 'flex',
  justifyContent: 'center',

  margin: 0,

  border: 0,
  borderTop: `0.1rem solid ${theme.colors.base06}`,
}));

export const EmptyListContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  color: theme.colors.base01,

  rowGap: '1.6rem',
}));

export const EmptyIconContainer = styled('div')({
  width: '6.6rem',
  height: '6.6rem',

  '& > svg': {
    width: '6.6rem',
    height: '6.6rem',
  },
});

export const StyledBottomSheet = styled(BottomSheet)({
  '& .MuiPaper-root': {
    height: '71rem',
    position: 'absolute',
    bottom: '0',

    '*::-webkit-scrollbar': {
      width: '0.1rem',
      height: '0.1rem',
      backgroundColor: 'transparent',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'white',
    },
    '*::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },
  },
});
